var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.75V1.625C0.751317 1.26073 0.896606 0.911761 1.15418 0.654184C1.41176 0.396606 1.76073 0.251317 2.125 0.25V0.25C2.48927 0.251317 2.83824 0.396606 3.09582 0.654184C3.35339 0.911761 3.49868 1.26073 3.5 1.625",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33234 3.16459C2.2983 2.98384 2.30088 2.79809 2.33991 2.61835C2.37895 2.43862 2.45364 2.26854 2.55958 2.11818C2.66552 1.96783 2.80055 1.84026 2.95667 1.74302C3.1128 1.64578 3.28684 1.58086 3.4685 1.55208C3.65017 1.52331 3.83576 1.53128 4.01429 1.57551C4.19281 1.61975 4.36065 1.69935 4.50787 1.80961C4.65508 1.91987 4.77868 2.05855 4.87134 2.21743C4.96401 2.37631 5.02385 2.55216 5.04734 2.73459",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10547 3.32781L5.31547 2.82031",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.25L3.015 4.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10938 6.10742L3.18688 7.44742",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 8.25L3.24938 8.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4L5.06 4.2425",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 5.75L5.75 7.005",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93945 7.75781L5.99945 8.00031",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.25L4.065 4.62",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32422 6.09766L4.55422 7.39266",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68555 8.12988L4.75055 8.49988",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11V13.25C15.25 13.7804 15.0393 14.2891 14.6642 14.6642C14.2891 15.0393 13.7804 15.25 13.25 15.25H2.75C2.21957 15.25 1.71086 15.0393 1.33579 14.6642C0.960714 14.2891 0.75 13.7804 0.75 13.25V11",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15.25L3 15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.25L13 15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11H0.75C0.617392 11 0.490215 10.9473 0.396447 10.8536C0.302678 10.7598 0.25 10.6326 0.25 10.5V9.75H15.75V10.5C15.75 10.6326 15.6973 10.7598 15.6036 10.8536C15.5098 10.9473 15.3826 11 15.25 11H14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1.25H10.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.25H15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.25H11.25C10.9848 0.25 10.7304 0.355357 10.5429 0.542893C10.3554 0.73043 10.25 0.984784 10.25 1.25V6.25H14V0.875C14 0.70924 14.0658 0.550269 14.1831 0.433058C14.3003 0.315848 14.4592 0.25 14.625 0.25V0.25C14.7908 0.25 14.9497 0.315848 15.0669 0.433058C15.1842 0.550269 15.25 0.70924 15.25 0.875V3.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.27209f1c.svg";
export { ForwardRef as ReactComponent };